class SchedulerController {
  constructor($rootScope, schedulerService, $timeout) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.schedulerService = schedulerService;
    this.$timeout = $timeout;
    this.name = 'scheduler';
    this.loading = true;
    this.getData();
  }

  getData() {
    this.$timeout(() => {
      this.schedulerService.getData(this.day).then((result) => {
        this.schedule = result.data.eventData;
        this.loading = false;
      });
    }, 750);
  }
}

export default SchedulerController;



// WEBPACK FOOTER //
// ./client/app/common/scheduler/scheduler.controller.js